import httpClient from './httpClient'

const apiGetShipInfo = val => httpClient.post('/inc/trackingv2.php', val),
    apiGetBrands = val => httpClient.post('/inc/brandsv2.php', val)

export { apiGetShipInfo, apiGetBrands }
